export const LANDING_SOCIAL_WALL_PREVIEW_FLAG = 'landing_social_wall_qa_preview';
